import http from './http-common';

class YarnTypeService {
  getAll() {
    return http.get('/yarnTypes');
  }
  getYarnTypesForYarnContract() {
    return http.get('yarnTypes/yarnTypesForYarnContract');
  }
  get(id) {
    return http.get(`/yarnTypes/${id}`);
  }

  create(data) {
    return http.post(`/yarnTypes/add`, data);
  }

  update(id, data) {
    console.log('data: ', data);
    return http.put(`/yarnTypes/${id}`, data);
  }

  delete(id) {
    return http.delete(`/yarnTypes/${id}`);
  }
}

export default new YarnTypeService();
